import React from 'react';
import { ConfigurationServiceV1 } from '@oneaudi/vtp-configuration-service';
import {
  CompleteVehicleEntry,
  DynamicFinancingValues,
  PriceItem,
  useMainPriceConfiguration,
  useServicesContext,
  VehicleBasic,
} from '@oneaudi/vtp-shared';
import { FSWrapper } from '../styles/ConversionBar.styles';
import { DisplayConversionbarPrice } from './DisplayConversionbarPrice';
import { DisplayConversionbarRate } from './DisplayConversionbarRate';

interface FinanceInfoConversionBarProps {
  vehicleRaw: CompleteVehicleEntry;
  vehicleBasic: VehicleBasic;
  dynamicFinancingValues?: DynamicFinancingValues;
  isColumn: boolean;
  updateDynamicFinancingValues?: (values?: DynamicFinancingValues) => void;
}

export const FinanceInfoConversionBar: React.FC<FinanceInfoConversionBarProps> = ({
  vehicleRaw,
  vehicleBasic,
  isColumn,
  dynamicFinancingValues,
  updateDynamicFinancingValues,
}) => {
  const configurationService =
    useServicesContext().getAdditionalService<ConfigurationServiceV1 | null>(
      'vtp-configuration-service'
    );
  const configuration = configurationService?.getConfiguration();

  const { mainPriceConfiguration } = configuration as unknown as any;
  const mainPrices: PriceItem[] = useMainPriceConfiguration(vehicleBasic, mainPriceConfiguration);
  const financeEnabled = configuration?.scopes?.financeEnabled || false;

  // Relvant Price Configurations
  const retailPriceConfig = mainPrices?.find((price) => price.priceType === 'retail');
  const staticRateConfig = mainPrices?.find((price) => price.priceType === 'rate');

  return (
    <FSWrapper>
      <DisplayConversionbarPrice priceConfig={retailPriceConfig} isColumn={isColumn} />
      <DisplayConversionbarRate
        staticRateConfig={staticRateConfig}
        dynamicFinancingValues={dynamicFinancingValues}
        updateDynamicFinancingValues={updateDynamicFinancingValues}
        vehicleRaw={vehicleRaw}
        financeEnabled={financeEnabled}
      />
    </FSWrapper>
  );
};
